import Grid from '@mui/material/Grid';
import AnalysisDescriptorsTable from 'pages/ScenarioExposure/Product/ScenariosManagement/AnalysisDescriptorsTable';
import Descriptors from 'pages/ScenarioExposure/Product/ScenariosManagement/DescriptorsTable';
import React from 'react';
import { SU } from 'utils/constants/descriptorTypes';
import { TABLE_HEIGHT_SPLIT_2VIEW } from 'utils/ui/constants';

const TABLE_HEIGHT = TABLE_HEIGHT_SPLIT_2VIEW(0);

const Component = props => {
  const { lcs, scenario, productScenarioDescriptors, substanceId } = props;

  return (
    <Grid container>
      <Grid size={7}>
        <Descriptors
          descriptorFilter={SU}
          scenario={scenario}
          substanceId={substanceId}
          lcs={lcs}
          TABLE_HEIGHT={TABLE_HEIGHT}
        />
      </Grid>
      <Grid size={5}>
        <AnalysisDescriptorsTable
          descriptorFilter={SU}
          productScenarioDescriptors={productScenarioDescriptors}
          TABLE_HEIGHT={TABLE_HEIGHT}
        />
      </Grid>
    </Grid>
  );
};

export default Component;
